import { Box, Table, TableHead, TableRow } from '@mui/material';
import { type MutableRefObject, type ReactNode } from 'react';

interface ReportWidgetStickyHeaderProps {
    headerHeight: number;
    headerTableWidth: number | null;
    tableMinWidth: number;
    stickyHeaderInnerRef: MutableRefObject<HTMLDivElement | null>;
    children: ReactNode;
}

export const ReportWidgetStickyHeader = ({
    headerHeight,
    headerTableWidth,
    tableMinWidth,
    stickyHeaderInnerRef,
    children,
}: ReportWidgetStickyHeaderProps) => (
    <Box
        sx={{
            position: 'sticky',
            top: 0,
            zIndex: 2,
            height: `${headerHeight}px`,
            marginBottom: `-${headerHeight}px`,
            overflow: 'hidden',
            pointerEvents: 'none',
            backgroundColor: 'background.paper',
        }}
    >
        <Box
            ref={stickyHeaderInnerRef}
            sx={{
                width: `${
                    headerTableWidth != null ? headerTableWidth : tableMinWidth
                }px`,
                pointerEvents: 'none',
            }}
        >
            <Table
                size="medium"
                sx={{
                    width: '100%',
                    minWidth: `${
                        headerTableWidth != null
                            ? headerTableWidth
                            : tableMinWidth
                    }px`,
                }}
            >
                <TableHead
                    sx={{
                        '& .MuiTableCell-head': {
                            backgroundColor: 'background.paper',
                            borderBottom: '1px solid',
                            borderColor: 'divider',
                        },
                    }}
                >
                    <TableRow>{children}</TableRow>
                </TableHead>
            </Table>
        </Box>
    </Box>
);
